import React from 'react';

import { isDigitalAssistantEnabled } from '@lumapps/digital-assistant/ducks/selectors';
import { SideNavigationItem, type SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { digitalAssistant } from '@lumapps/lumx/custom-icons';
import { useSelector } from '@lumapps/redux/react';
import { useTranslate, GLOBAL } from '@lumapps/translations';

import { digitalAssistantAdminRoute } from '../../routes';

export interface DigitalAssistantSideNavigationProps extends Partial<SideNavigationItemProps> {
    /** has the user access to the digital assistant section */
    isAllowed?: boolean;
}

const DigitalAssistantSideNavigation: React.FC<Partial<DigitalAssistantSideNavigationProps>> = ({
    isAllowed,
    ...restOfProps
}) => {
    const { translateKey } = useTranslate();

    if (!useSelector(isDigitalAssistantEnabled) || !isAllowed) {
        return null;
    }

    return (
        <SideNavigationItem
            {...restOfProps}
            route={digitalAssistantAdminRoute}
            label={translateKey(GLOBAL.DIGITAL_ASSISTANT)}
            icon={digitalAssistant}
        />
    );
};

DigitalAssistantSideNavigation.displayName = 'SideNavigationItem';

export { DigitalAssistantSideNavigation };
